import React from 'react'
import AdminRoutes from '../UserRoutes/AdminRoutes'
import '../../../styles/userStyles/Admin.css'
function Content() {
    return (
        <div className="admin--content"><AdminRoutes /></div>
    )
}

export default Content